// This is the main module where we will determine whether the user is logged in, not banned, etc.,
// and make necessary preparations (for example initializing the redux store wil the main data we need)

import React from "react";
import { createRoutesFromElements, Route } from "react-router-dom";
import PublicModule from "./open";
import PrivateModule from "./private";
import { Landing } from "./landing";

export const mainRoutes = createRoutesFromElements(
  <>
    <Route index element={<Landing />} />
    <Route index path="*" element={<PublicModule />} />
    <Route path="private/*" element={<PrivateModule />} />
  </>
);
